import { render, staticRenderFns } from "./wl-notice.vue?vue&type=template&id=140e0365&scoped=true&"
import script from "./wl-notice.vue?vue&type=script&lang=js&"
export * from "./wl-notice.vue?vue&type=script&lang=js&"
import style0 from "./wl-notice.vue?vue&type=style&index=0&id=140e0365&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e0365",
  null
  
)

export default component.exports